module.exports = __webpack_public_path__ + "static/img/network01.2749fd84.png";